import { Layout } from 'Components/Layout/Layout';
import { OrderDetails } from 'Containers/Orders/OrderDetails/OrderDetails';

export const OrderDetailsPage = () => {
  return (
    <Layout>
      <OrderDetails />
    </Layout>
  );
};
